const peiGoalMeasures = {
  unSet: 0,
  attempts: 42,
  percentual: 44,
};

export default peiGoalMeasures;
